import DropDown from './dropdown'
import Editor from './editor'
import Input from './input'
import Password from './password'
import TextArea from './textarea'
import Upload from './upload'
import PhoneInput from './phone'
import OtpInput from './otp'
import ChooseBox from './choosebox'
import Checkbox from './checkbox'

export default {
  DropDown,
  Editor,
  Input,
  Password,
  TextArea,
  Upload,
  PhoneInput,
  OtpInput,
  ChooseBox,
  Checkbox,
}
